import { CircularProgress } from "@material-ui/core";

export type LoadingProps = {
  loading: boolean;
};
export const Loading = ({ loading }: LoadingProps) =>
  loading ? <CircularProgress color="inherit" size={20} /> : null;
